import { akeronService } from "./akeronService";

const section = "ProductFamily";

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return akeronService.make_get_request(`${section}/ListProductFamily/${name}/${from}/${limit}/${active}`, {}).then((response) => {
    let result = {
      quantity: response.quantity || 0,
      list: response.productFamilies || response.families || response.list || [],
    };
    return result;
  });
}

function getAll() {
  return akeronService.make_get_request(`${section}/ListAll`, {}).then((response) => {
    return response.productFamilies || response.families || response.list || [];
  });
}

function remove(id) {
  return akeronService.make_delete_request(`${section}/DeleteProductFamily/${id}`, {});
}

function create(item) {
  const param = {
    Name: item.name,
    LineId: item.line.id,
  };
  return akeronService.make_post_request(`${section}/CreateProductFamily`, param);
}

function update(item) {
  const param = {
    id: item.id,
    Name: item.name,
    LineId: item.line.id,
    IsActive: item.isActive !== undefined ? item.isActive : true,
  };
  return akeronService.make_put_request(`${section}/UpdateProductFamily`, param);
}

export const familiaProductoService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
